
import { createRouter, createWebHistory } from 'vue-router'

/* Layout */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('./views/login/index'),
    redirect: '/oauth',
    hidden: true
  },
  {
    path: '/oauth',
    component: () => import('./views/login/oauth'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('./views/404'),
    hidden: true
  },
  {
    path: '/not-support',
    component: () => import('./views/Notsupport'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('./views/indicatrix/index'),
    children: [
      {
        path: '/',
        name: 'projectSearch',
        component: () => import('./views/indicatrix/list/project-list')
      },
      {
        name: 'newProjectItem',
        path: '/project',
        component: () => import('./views/indicatrix/project-item'),
        props: route => ({ edit: route.params['edit'] === '1' })
        ,
        children: [
          //新建项目
          {
            name: 'projectNew',
            path: 'new',
            component: () => import('./views/indicatrix/project-info'),
            props: route => ({ edit: true })
          },
        ]
      },

      {
        name: 'projectItem',
        path: '/project/:topProjectId',
        component: () => import('./views/indicatrix/project-item'),
        props: (router) => ({ topProjectId: router.params.topProjectId, edit: router.query.edit }),
        children: [
          //查看总项信息
          {
            name: 'topProjectInfo',
            path: 'info',
            component: () => import('./views/indicatrix/project-info')
          },
          //查看子项信息
          {
            name: 'projectInfo',
            path: 'info/:projectId',
            component: () => import('./views/indicatrix/project-info'),
            props: true
          },
          // //编辑总项目
          // {
          //   name: 'editTopProjectInfo',
          //   path: '/:topProjectId/info?edit=1',
          //   component:  () => import('./views/indicatrix/project-info'),
          //   props: true
          // },
          // //编辑子项目
          // {
          //   name: 'editProjectInfo',
          //   path: '/:topProjectId/info/:projectId?edit=1',
          //   component:  () => import('./views/indicatrix/project-info'),
          //   props: true
          // },
          //查看指定项目的默认指标视图      
          {
            name: 'projectIndicatrix',
            path: 'indx',
            component: () => import('./views/indicatrix/project-indicatrix')

          },
          //查看指定项目的指定指标视图
          {
            name: 'projectIndicatrixView',
            path: 'indx/:viewId',
            component: () => import('./views/indicatrix/project-indicatrix'),
            props: (router) => ({ viewId: router.params.viewId })
          },
          //项目文件
          {
            name: 'projectFiles',
            path: 'files',
            component: () => import('./views/indicatrix/project-file')
          },
          //项目设置
          //采集方案
          {
            name: 'settingCollectSchema',
            path: 'setting/collect-schema',
            component: {
              projectSetting: () => import('./views/indicatrix/setting/collect-schema')
            }
          }
        ]
      },

      // 对比指标
      {
        name: 'compareIndicatrix',
        path: '/indicatrix/compare',
        component: () => import('./views/indicatrix/compare/indicatrix-compare')
      },
      // 我的
      {
        name: 'myProject',
        path: '/mine',
        component: () => import('./views/indicatrix/list/project-of-mine')
      },
      //管理
      {
        name: 'adminProjectManage',
        path: '/admin/project-manage',
        component: () => import('./views/indicatrix/admin/project-manage')
      },
    ]
  },

  // 404 page must be placed at the end !!!
  { path: '/:catchAll(.*)', redirect: '/404', hidden: true }
]

const createMyRouter = () => createRouter({
  scrollBehavior: () => ({ y: 0 }),
  history: createWebHistory(),
  routes: constantRoutes
})

const router = createMyRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createMyRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
